import { render, staticRenderFns } from "./DataCenterNav.vue?vue&type=template&id=664c54b8&scoped=true"
import script from "./DataCenterNav.vue?vue&type=script&lang=js"
export * from "./DataCenterNav.vue?vue&type=script&lang=js"
import style0 from "./DataCenterNav.vue?vue&type=style&index=0&id=664c54b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664c54b8",
  null
  
)

export default component.exports